import React from 'react';
import { DashboardLayout } from '@blumtechgroup/blum-react-core-components';
import { useNavigate } from 'react-router-dom';
import { ListClinicianUsersComponent } from '../../../../components/Global';

const ListClinicianUsers = (): React.ReactElement => {
  const navigate = useNavigate();

  const handleView = (clinicianId: string) => {
    navigate(`/loc/clinicians/${clinicianId}`);
  };

  const handleEdit = (clinicianId: string) => {
    navigate(`/loc/clinicians/${clinicianId}/edit`);
  };

  const handleCreate = () => {
    navigate(`/loc/clinicians/create`);
  };

  return (
    <DashboardLayout breadcrumbs={[{ label: 'Home', link: '/loc/home' }, { label: 'Clinicians' }]}>
      <ListClinicianUsersComponent handleView={handleView} handleEdit={handleEdit} handleCreate={handleCreate} />
    </DashboardLayout>
  );
};

export default ListClinicianUsers;
